@file:OptIn(InternalResourceApi::class)

package ifaandroid.feature.content.insights.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DensityQualifier
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String =
    "composeResources/ifaandroid.feature.content.insights.generated.resources/"

@delegate:ResourceContentHash(-1_329_275_321)
internal val Res.drawable.bg_mealplan_topbar: DrawableResource by lazy {
      DrawableResource("drawable:bg_mealplan_topbar", setOf(
        ResourceItem(setOf(), "${MD}drawable/bg_mealplan_topbar.jpg", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_412_856_818)
internal val Res.drawable.bg_workouts_topbar: DrawableResource by lazy {
      DrawableResource("drawable:bg_workouts_topbar", setOf(
        ResourceItem(setOf(DensityQualifier.XHDPI, ), "${MD}drawable-xhdpi/bg_workouts_topbar.jpg", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXHDPI, ), "${MD}drawable-xxhdpi/bg_workouts_topbar.jpg", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXXHDPI, ), "${MD}drawable-xxxhdpi/bg_workouts_topbar.jpg", -1, -1),
      ))
    }

@delegate:ResourceContentHash(7_156_505)
internal val Res.drawable.ic_bookmark_24: DrawableResource by lazy {
      DrawableResource("drawable:ic_bookmark_24", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_bookmark_24.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-670_277_567)
internal val Res.drawable.ic_bookmark_filled_24: DrawableResource by lazy {
      DrawableResource("drawable:ic_bookmark_filled_24", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_bookmark_filled_24.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_614_830_528)
internal val Res.drawable.ic_clock_16: DrawableResource by lazy {
      DrawableResource("drawable:ic_clock_16", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_clock_16.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_644_930_492)
internal val Res.drawable.ic_refresh_24: DrawableResource by lazy {
      DrawableResource("drawable:ic_refresh_24", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_refresh_24.xml", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("bg_mealplan_topbar", Res.drawable.bg_mealplan_topbar)
  map.put("bg_workouts_topbar", Res.drawable.bg_workouts_topbar)
  map.put("ic_bookmark_24", Res.drawable.ic_bookmark_24)
  map.put("ic_bookmark_filled_24", Res.drawable.ic_bookmark_filled_24)
  map.put("ic_clock_16", Res.drawable.ic_clock_16)
  map.put("ic_refresh_24", Res.drawable.ic_refresh_24)
}
